import { get, cloneDeep, has } from "lodash";
import moment from "moment";

/*
RSSI CHART
*/
let ephocDate = (input) => {
  let miliSecondsFromEpoc = (parseInt(input, 10) / 32768) * 1000;
  let date = new Date(0); //Date(0) represents the epoc date
  date.setUTCMilliseconds(miliSecondsFromEpoc);
  return date;
};

let getRSSIChartModel = (reports) => {
  // if($scope.reportable.type === 'chime') {
  //   date = $filter('formatDate')(report.timestamp, 'MM/DD/YYYY HH:mm:ss:SSS', chartTimezone);
  //   rssi = report.data.status.mgmnt_rssi;
  // }
  let isChime = get(reports, "[0].type", null) === "chime";
  let rssiPath = isChime ? "data.status.mgmnt_rssi" : "data.status.rssi";
  let datePath = isChime ? "timestamp" : "data.status.time";

  return reports
    .map((report) => {
      let rssi = get(report, rssiPath);
      if (typeof rssi === "undefined") return null;
      let time = get(report, datePath, null);
      let date;
      if (isChime) date = time;
      else date = ephocDate(time);
      return {
        name: moment(date).format("MM/DD/YYYY HH:mm:ss:SSS"),
        y: parseFloat(rssi),
      };
    })
    .filter((rssi) => rssi !== null);
};

/*
STREAM CHART
*/
let getStreamChartModel = (reports) => {
  return reports
    .map((report) => {
      let hasStreamProfile = get(report, "data.statistics", {}).hasOwnProperty(
        "end_stream_profile"
      );
      if (hasStreamProfile) {
        let streamProfile = get(report, "data.statistics.end_stream_profile");
        let time =
          get(report, "data.statistics.sip_connect_time") ||
          get(report, "data.statistics.wake_up_time");
        let streamChunk = Math.abs(parseFloat(streamProfile));
        let date = ephocDate(time);
        return {
          name: moment(date).format("MM/DD/YYYY HH:mm:ss:SSS"),
          y: streamChunk,
        };
      } else return null;
    })
    .filter((stream) => stream !== null);
};

/*
BATTERY CHART
*/

let BatteryChartModel = {
  percentages: null,
  errors: null,
  isDPD: null,
  isLPD: null,
  batteryCharge: 0,
  batteryCharge2: null,
  has2ndBattery: false,
  init: function (report, date) {
    this.date = date;
    this.has2ndBattery = has(report, "data.status.battery_percentage_2");
    this.i2cErrors = parseInt(get(report, "data.status.i2c_errors", 0));
    this.isDPD = report.data.status.hasOwnProperty("battery_percentage");
    this.isLPD = !this.isDPD;
    this.battery_percentage = parseInt(
      get(report, "data.status.battery_percentage", 0)
    );
    this.battery_percentage_2 = parseInt(
      get(report, "data.status.battery_percentage_2", 0)
    );
    this.battery_voltage = parseFloat(
      get(report, "data.status.battery_voltage", 0)
    );
    this.battery_voltage_2 = parseFloat(
      get(report, "data.status.battery_voltage_2", 0)
    );
    this.setBatteryValue();
    this.set2ndBatteryCharge();
    return this;
  },
  addToBatteryErrorsChart(chartPoints) {
    if (this.hasErrors())
      chartPoints.unshift({
        y: 0,
        name: "Fuel Guage Error: " + this.batteryCharge,
      });
    else chartPoints.unshift({ y: null });
  },
  addToBatteryChart(chartPoints) {
    let charge = this.hasErrors() ? null : this.batteryCharge;
    let node = { name: this.date, y: parseFloat(charge) };
    chartPoints.unshift(node);
  },
  addTo2ndBatteryChart(chartPoints) {
    if (!this.has2ndBattery) return;
    let node = { name: this.date, y: parseFloat(this.batteryCharge2) };
    chartPoints.unshift(node);
  },
  setBatteryValue: function () {
    if (this.isDPD) this.batteryCharge = this.battery_percentage;
    if (this.isLPD)
      this.batteryCharge = this.voltageToPercentage(this.battery_voltage);
  },
  hasErrors() {
    return this.errorReported() && this.errorEncodedInBattery();
  },
  errorEncodedInBattery() {
    return this.batteryCharge >= 200 && this.batteryCharge <= 300;
  },
  errorReported() {
    return (this.i2cErrors & 2) == 2 || (this.i2cErrors & 4) == 4;
  },
  voltageToPercentage(value) {
    let voltage = parseFloat(value || 0);
    let calculated_percentage = Math.round(voltage * 0.143 - 485);
    return Math.min(Math.max(calculated_percentage, 0), 100);
  },
  set2ndBatteryCharge() {
    if (!this.has2ndBattery) return;
    let charge = 0;
    if (this.isDPD) {
      charge = parseInt(this.battery_percentage_2);
      this.batteryCharge2 = charge <= 100 ? charge : 0;
    }
    if (this.isLPD)
      this.batteryCharge2 = this.voltageToPercentage(this.battery_voltage_2);
  },
};

let initialModels = {
  isLPD: false,
  categories: [],
  stream: [],
  rssi: [],
  battery: [],
  battery2: [],
  batteryErrors: [],
};
let models = {};

function getChartModels(reports) {
  models = cloneDeep(initialModels);
  reports.forEach((report) => {
    let date = ephocDate(report.data.status.time);
    date = moment(date).format("MM/DD/YYYY HH:mm:ss:SSS");
    models.categories.unshift(date);
    let batteryChart = Object.create(BatteryChartModel).init(report, date);
    batteryChart.addToBatteryChart(models.battery);
    batteryChart.addTo2ndBatteryChart(models.battery2);
    batteryChart.addToBatteryErrorsChart(models.batteryErrors);
  });
  models.rssi = getRSSIChartModel(reports);
  models.stream = getStreamChartModel(reports);
  return models;
}

export default getChartModels;
